import { useEffect, useState } from 'react';
import { useCurrentProjectId } from '@adsk/alloy-provider';
import { useDataApi } from '@adsk/alloy-helpers';
import { buildGetProjectRequest } from './utils';

const useGetProjectProducts = (enable = true) => {
  const projectId = useCurrentProjectId();
  const [projectProducts, setProjectProducts] = useState();
  const {
    data: projectData,
    doFetch: doGetProject,
    loading: isLoadingProjectData,
    setData,
  } = useDataApi();

  useEffect(() => {
    if (!projectId || projectProducts !== undefined || !enable) return;

    doGetProject(buildGetProjectRequest(projectId));
  }, [enable, projectId, doGetProject, projectProducts]);

  useEffect(() => {
    if (!projectData || isLoadingProjectData || !enable) return;
    setProjectProducts(projectData.products);
    setData(null);
  }, [enable, projectData, isLoadingProjectData, projectProducts, setData]);

  return {
    projectProducts,
    isLoadingProjectData,
  };
};

export default useGetProjectProducts;
